// Flots - English translations (JSON format for react-intl)
const en: Record<string, string> = {
  // ----- Navigation -----
  "nav.features": "Features",
  "nav.centralization": "Centralized Management",
  "nav.suggestions": "Automatic Suggestions",
  "nav.notifications": "Smart Notifications",
  "nav.pricing": "Pricing",
  "nav.team": "Team",
  "nav.contact": "Contact",
  "nav.cta": "Open Flots",
  // Sign-up pill of the mobile app bar: kept short, it shares the bar with the brand and the menu.
  "nav.ctaShort": "Try it free",

  // ----- Promo Banner -----
  "promo.banner.text": "2 months free on every plan, no credit card",
  "promo.banner.textShort": "2 months free on every plan",
  "promo.banner.cta": "Get the offer",

  // ----- Hero Section -----
  "hero.discount": "50% discount",
  "hero.discountUntil": "until January 15",
  "hero.titleNeed": "Need a",
  "hero.titleSecretary": "Pocket",
  "hero.titlePocket": "Secretary?",
  "hero.description":
    "Discover a tool designed to help you with your organization, adaptable to your daily life and easy to use.",
  "hero.cta": "Try free for 30 days",
  "hero.noCreditCard": "no",
  "hero.ccRequired": "required",
  "hero.users": "+100 users have already joined us",
  "hero.available": "Available everywhere",
  "hero.titleOrganization": "Your organization,",
  "hero.titleSimplified": "simplified",
  "hero.benefit1Title": "Nothing to build.",
  "hero.benefit1Desc": "Tools your team already knows. Five minutes, and you are working.",
  "hero.benefit2Title": "From meeting to action.",
  "hero.benefit2Desc": "Your notes become tasks: Cap suggests, you confirm.",
  "hero.benefit3Title": "Your data stays yours.",
  "hero.benefit3Desc": "Hosted in Europe. Everyone chooses what they share.",
  "hero.ctaPrimary": "Try Flots for free",
  "hero.ctaSecondary": "Request a demo",
  "hero.freeBadge": "2 months free",
  "hero.noCard": "no credit card",
  "hero.subhead":
    "Tasks, calendar, notes and projects in one European tool, usable in five minutes, with nothing to configure.",
  "hero.availableOn": "Available on",
  "hero.web": "Web",
  "hero.appStore": "App Store",
  "hero.googlePlay": "Google Play",
  "hero.devices": "on your computer, smartphone and tablet",
  "hero.word1": "simplified",
  "hero.word2": "clarified",
  "hero.word3": "optimized",
  "hero.word4": "mastered",
  "hero.whoAreYou": "Who are you?",
  "hero.individual": "An individual",
  "hero.organization": "An organisation",
  "hero.feature1Title": "Everything in one place, usable right away",
  "hero.feature1Desc":
    "Tasks, calendar, notes, projects. Your schedule and your knowledge in one place, without juggling five tools.",
  "hero.feature1Point1Title": "Everything in one place.",
  "hero.feature1Point1Desc":
    "One client, one space: their notes, deadlines and deliverables.",
  "hero.feature1Point2Title": "Find anything in three seconds.",
  "hero.feature1Point2Desc":
    "One search, and the information comes up, wherever you filed it.",
  "hero.feature1Point3Title": "No double entry.",
  "hero.feature1Point3Desc":
    "What you write down once shows up everywhere it matters.",
  "hero.feature2Title": "Nothing to build, nothing to learn",
  "hero.feature2Desc":
    "Create a task or a note in two clicks, and find them effortlessly. The tool adapts to the way you work, not the other way around.",
  "hero.feature2Point1Title": "Up and running in five minutes.",
  "hero.feature2Point1Desc": "Nothing to configure, nothing to maintain.",
  "hero.feature2Point2Title": "Two clicks, not ten.",
  "hero.feature2Point2Desc": "Capturing an idea never breaks your flow.",
  "hero.feature2Point3Title": "On every screen.",
  "hero.feature2Point3Desc":
    "Mobile, tablet, browser: the same organization everywhere.",
  "hero.feature3Title": "From meeting to action, without thinking about it",
  "hero.feature3Desc":
    "Your meeting notes become tasks that you confirm or correct. Cap suggests, you decide.",
  "hero.feature3Point1Title": "You see what matters coming.",
  "hero.feature3Point1Desc":
    "What is urgent rises to the top, the rest waits its turn.",
  "hero.feature3Point2Title": "Your day is prepared at the time you choose.",
  "hero.feature3Point2Desc": "The assistant suggests, you adjust.",
  "hero.feature3Point3Title": "You free up your mind.",
  "hero.feature3Point3Desc":
    "Organizing does not become your second job.",


  // ----- Application Section -----
  "app.title": "The Flots Application",
  "app.needOrganization": "solid organization",
  "app.busyLife": "busy daily life",
  "app.manyProjects": "many ongoing projects",
  "app.deadlines": "with their own deadlines, requirements and knowledge?",
  "app.clarity": "clarity in your projects",
  "app.calendar": "calendar",
  "app.tasks": "tasks",
  "app.notes": "notes",
  "app.samePlace": "in one place and take advantage of our",
  "app.ai": "advanced AIs",
  "app.aiSuffix": "to assist you.",
  "app.easeOfUse": "thoughtful ease of use",
  "app.adapts": "adapts to you",
  "app.enjoyEase": "Enjoy a",
  "app.forOnce": "For once, it's the tool that",
  "app.or": "or",
  "app.tryYourself": "Try it yourself",
  "app.videoButton": "Let us introduce Flots",
  "app.needIntro": "Need a",
  "app.toFace": "to face a",
  "app.questionMark": "Many",
  "app.flotsGives": "Flots brings you",
  "app.findYour": "Find your",
  "app.your": "your",
  "app.and": "and your",

  // ----- How/Promise Section -----
  "how.title": "Our Promise",
  "how.promise1": "We want to enable freelancers and small teams to",
  "how.promise1Focus": "spend less time on organization",
  "how.promise1End": "to",
  "how.promise1Essential": "focus on what matters",
  "how.promise1Suffix": "in their work: their projects and clients.",
  "how.promise2": "We aim for a",
  "how.promise2Human": "human approach",
  "how.promise2Middle":
    ", based on daily understanding of our users' needs and constraints to develop",
  "how.promise2Tech": "adapted technologies",
  "how.tagline1": "A tool",
  "how.taglinePresent": "present",
  "how.tagline2": "when needed, able to",
  "how.taglineAnticipate": "anticipate",
  "how.tagline3": "your workload and",
  "how.taglineBlend": "blend",
  "how.tagline4": "into your habits...",
  "how.cta": "Who are we?",

  // ----- Features Section -----
  "features.title": "Features",
  "features.centralizationTitle": "Centralized Management",
  "features.centralizationDesc":
    "Tired of juggling between your notes, calendar, and tasks to stay up to date? With Flots, access all your tools in one place from any platform.",
  "features.suggestionsTitle": "Automatic Suggestions",
  "features.suggestionsEta": "Expected release March 2026",
  "features.suggestionsDesc":
    "Take notes without overthinking, and let us detect the tasks you've described, automatically categorize them, or summarize them for a brief overview.",
  "features.notificationsTitle": "Smart Notifications",
  "features.notificationsEta": "Expected release May 2026",
  "features.notificationsDesc":
    "Don't miss important information. Be aware of your workload and stop letting urgent matters get lost among the hundreds of notifications we receive daily.",

  // ----- Pricing Section -----
  "pricing.title": "Our Pricing",
  "pricing.trialTitle": "Trial Plan",
  "pricing.trialPrice": "Free",
  "pricing.trialDuration": "for 30 days",
  "pricing.trialFeature1": "Access to standard features of the individual plan",
  "pricing.trialFeature2": "Test the application in real conditions",
  "pricing.trialCta": "Try",
  "pricing.individualDiscount": "-30% until February",
  "pricing.individualYearlyDiscount": "-50% until February",
  "pricing.individualTitle": "Individual Plan",
  "pricing.perMonth": "(Exc. Taxes) / month",
  "pricing.perYear": "(Exc. Taxes) / year",
  "pricing.noCommitment": "no commitment for 12 months",
  "pricing.individualFeature1": "Unlimited access to the application",
  "pricing.individualFeature2": "Automatic suggestions (Incoming soon)",
  "pricing.individualFeature3": "Smart notifications",
  "pricing.individualFeature4": "Advanced customer support",
  "pricing.individualCta": "Get Started",
  "pricing.teamTitle": "Annual Plan",
  "pricing.teamEta": "-50% discount!",
  "pricing.teamUsers5": "Up to 5 users",
  "pricing.teamUsers10": "Up to 10 users",
  "pricing.interested": "interested?",
  "pricing.teamCta": "Contact Us",
  "pricing.modalTitle": "Thank you for your interest!",
  "pricing.modalDesc":
    "We're finishing the final preparations for the new version. It will be ready mid-November 2025. Follow us on LinkedIn to know when it's released!",
  "pricing.modalLinkedin": "Our LinkedIn",
  "pricing.modalPrototype": "Free prototype already available everywhere!",

  // ----- Comparison Section -----
  "compare.badge": "Comparison",
  "compare.switch.label": "Compare for",
  "compare.switch.team": "Team",
  "compare.switch.individual": "Individual",
  "compare.criteriaHeader": "Criterion",
  "compare.support.yes": "Yes",
  "compare.support.partial": "Partially",
  "compare.support.no": "No",
  "compare.price.unavailable": "Price unavailable",
  "compare.team.title": "A simple French alternative to Notion, Trello or Todoist for your team",
  "compare.team.subtitle":
    "Big platforms need a dedicated role. Small tools leave the wiring to you. Flots Team is up and running the same day, with nothing to configure.",
  "compare.team.caption":
    "Comparison of the Flots Team plan with Notion Business, Trello Premium and Todoist Business across five criteria and the price per user",
  "compare.team.plan.flots": "Team",
  "compare.team.plan.notion": "Business",
  "compare.team.plan.trello": "Premium",
  "compare.team.plan.todoist": "Business",
  "compare.team.row.centralization": "My team finds its tasks, calendar and notes in one place",
  "compare.team.row.notesToTasks": "Meeting notes turn into tasks, with no retyping",
  "compare.team.row.noSetup": "My team gets started the same day, with nothing to set up",
  "compare.team.row.frenchSupport": "My team gets help from a European team it can actually reach",
  "compare.team.row.euHosting": "My company's data is hosted by Europeans",
  "compare.team.row.price": "What I pay per user per month, business plan",
  "compare.team.price.notion": "$20",
  "compare.team.price.trello": "$12.50",
  "compare.team.price.todoist": "$10",
  "compare.team.footnote":
    "Business plans billed monthly, per user: Notion Business, Trello Premium and Todoist Business, public prices in US dollars read in October 2026 on their pricing pages, before annual discounts. Flots Team: tax-exclusive price from the Flots catalogue, in euros.",
  "compare.individual.title": "A simple French alternative to Notion, Trello or Todoist",
  "compare.individual.subtitle":
    "Big platforms need a dedicated role. Small tools leave the wiring to you. Flots is up and running in 5 minutes, with nothing to configure.",
  "compare.individual.caption":
    "Comparison of the Flots Individual plan with Notion Plus, Trello Standard and Todoist Pro across five criteria and the monthly price",
  "compare.individual.plan.flots": "Individual",
  "compare.individual.plan.notion": "Plus",
  "compare.individual.plan.trello": "Standard",
  "compare.individual.plan.todoist": "Pro",
  "compare.individual.row.centralization": "I find my tasks, my calendar and my notes in one place",
  "compare.individual.row.notesToTasks": "My notes turn into tasks effortlessly",
  "compare.individual.row.noSetup": "I get started without setting anything up",
  "compare.individual.row.frenchSupport": "I get help from a European team I can actually reach",
  "compare.individual.row.euHosting": "My data is hosted by Europeans",
  "compare.individual.row.price": "What I pay per month, individual plan",
  "compare.individual.price.notion": "$10",
  "compare.individual.price.trello": "$6",
  "compare.individual.price.todoist": "$7",
  "compare.individual.footnote":
    "Individual plans billed monthly: Notion Plus, Trello Standard and Todoist Pro, public prices in US dollars read in October 2026 on their pricing pages, before annual discounts. Flots Individual: tax-exclusive price from the Flots catalogue, in euros.",

  // ----- Pricing Section v3 -----
  "pricing3.eyebrow": "Pricing",
  "pricing3.title": "Simple pricing, no commitment",
  "pricing3.subtitle":
    "2 months free on every plan, no credit card. Cancel whenever you want.",
  "pricing3.billingCycle": "Billing cycle",
  "pricing3.monthly": "Monthly",
  "pricing3.annual": "Annual",
  "pricing3.annualWithDiscount": "Annual −{percent}%",
  "pricing3.priceMode": "Price display",
  "pricing3.priceMode.ht": "Excl. tax",
  "pricing3.priceMode.ttc": "Incl. tax",
  "pricing3.priceUnavailable": "Price unavailable",
  "pricing3.trial": "2-month free trial",
  "pricing3.billedAnnually": "billed annually, 2-month free trial",
  "pricing3.annualTotal": "i.e., {total}/year",
  // Phones and tablets: a plan card's feature list opens on its first lines.
  "pricing3.featuresMore": "{count, plural, one {See one more feature} other {See # more features}}",
  "pricing3.featuresLess": "Show less",

  "pricing3.indiv.badge": "2 months free",
  "pricing3.indiv.title": "Individual",
  "pricing3.indiv.desc":
    "For people working on their own, with a few projects to manage.",
  "pricing3.indiv.unit": "/ month",
  "pricing3.indiv.f1": "Unlimited tasks and calendar",
  "pricing3.indiv.f2": "512 MB of storage (docs, notes…)",
  "pricing3.indiv.f3": "3 shared projects, up to 3 collaborators",
  "pricing3.indiv.f4": "Personal workspace",
  "pricing3.indiv.f5": "MCP access",
  "pricing3.indiv.f6": "Cap access: 300 credits",
  "pricing3.indiv.f7": "Automatic import (Notion, Todoist)",

  "pricing3.pro.badge": "Most popular",
  "pricing3.pro.title": "Pro",
  "pricing3.pro.desc":
    "For people working alone or in a group, with more demanding needs.",
  "pricing3.pro.unit": "/ month",
  "pricing3.pro.f1": "Unlimited tasks and calendar",
  "pricing3.pro.f2": "10 GB of storage (docs, notes…)",
  "pricing3.pro.f3": "Unlimited projects",
  "pricing3.pro.f4": "Personal workspace + 1 organisation",
  "pricing3.pro.f5": "MCP access",
  "pricing3.pro.f6": "Cap access: 750 credits",
  "pricing3.pro.f7": "Automatic import (Notion, Todoist)",
  "pricing3.pro.f8": "All integrations (Drive, GitHub)",

  "pricing3.team.badge": "Team management",
  "pricing3.team.title": "Team",
  "pricing3.team.desc":
    "For teams that need to work together efficiently.",
  "pricing3.team.unit": "/ user / month",
  "pricing3.team.f1": "Unlimited tasks and calendar",
  "pricing3.team.f2": "100 GB of storage (docs, notes…)",
  "pricing3.team.f3": "Unlimited projects",
  "pricing3.team.f4": "10 organisations",
  "pricing3.team.f5": "MCP access",
  "pricing3.team.f6": "Cap access: 1500 credits",
  "pricing3.team.f7": "Automatic import (Notion, Todoist)",
  "pricing3.team.f8": "All integrations (Drive, GitHub)",
  "pricing3.team.f9": "Single invoice for the whole team",
  "pricing3.team.f10": "Secrets vault (coming soon)",

  "pricing3.cta.trial": "Try for free",
  "pricing3.cta.demo": "Book a demo",
  "pricing3.reassurance.payment": "Pay securely by credit card",
  "pricing3.reassurance.manage":
    "Manage your subscription and preferences from your account",
  "pricing3.reassurance.cancel": "Cancel in one click, no commitment",

  // ----- FAQ Section -----
  "faq.eyebrow": "FAQ",
  "faq.title": "Frequently asked questions",
  "faq.subtitle":
    "Everything you are wondering about before you start. A question that is not here? We answer within 24 hours.",

  "faq.free.q": "Is it really free?",
  "faq.free.a":
    "Yes. You try the plan of your choice free for 2 months, no credit card. After that, no commitment: you stop in one click.",

  "faq.devices.q": "Which devices can I organise on?",
  "faq.devices.a":
    "Web, iOS, Android, tablet and iPad. Your tasks, your calendar and your notes sync everywhere.",

  "faq.onboarding.q": "How long before I am up and running?",
  "faq.onboarding.a":
    "Five minutes. Nothing to configure, nothing to maintain: you start capturing and organising as soon as you sign up. You can automatically import your data from your favourite app (Notion, Todoist) to start right away with your own content.",

  "faq.import.q": "Can I bring my data from Notion, Trello or Todoist?",
  "faq.import.a":
    "Yes, for Notion and Todoist today. The Trello import is on its way.",

  "faq.billing.q": "How do I manage my subscription and preferences?",
  "faq.billing.a":
    "Everything happens in your customer area: change plan, update your card, or cancel in one click, without contacting us.",

  "faq.team.q": "Can I use it with my team?",
  "faq.team.a":
    "Yes. The Pro plan lets you share projects without limit. The Team plan adds multi-organisation management, centralised billing and team workload tracking.",

  "faq.data.q": "Where is my data stored?",
  "faq.data.a":
    "Hosted in Europe. All our providers comply with GDPR. Your data is never sold to third parties.",

  "faq.more.title": "Still missing an answer?",
  "faq.more.desc":
    "Tell us about your setup and what is blocking you. We answer within 24 hours.",
  "faq.more.contact": "Write to us",
  "faq.more.demo": "Book a demo",

  // ----- Final CTA -----
  "finalCta.title": "Tomorrow morning, you will know where to start",
  "finalCta.subtitle":
    "Create your account in 30 seconds. 2 months free, no credit card.",
  "finalCta.signup": "Create my free account",
  "finalCta.demo": "Book a demo",

  // ----- Contact Section -----
  "contact.title": "Contact Us",
  "contact.subtitle": "We respond within 24 hours.",
  "contact.intro.title": "Let's talk about your organization",
  "contact.intro.desc":
    "A question, an idea, or want to see Flots in action? Write to us and we'll get back to you quickly.",
  "contact.demo.title": "Request a demo",
  "contact.demo.desc":
    "Prefer a live conversation? Book a slot with our team.",
  "contact.demo.cta": "Book a slot",
  "contact.success": "Message sent! We'll get back to you within 24 hours.",
  "contact.sendAnother": "Send another message",
  "contact.formTitle": "Form",
  "contact.formDesc":
    "Use this form to contact us. We will respond as soon as possible. Please provide as many details as possible for a more relevant response.",
  "contact.name": "Name",
  "contact.email": "Email",
  "contact.subject": "SUBJECT",
  "contact.content": "CONTENT",
  "contact.placeholder": "Describe your request",
  "contact.submit": "Send",
  "contact.sending": "Sending...",
  "contact.selectSubject": "Select a subject",
  "contact.subjectSubscriptions": "Subscriptions",
  "contact.subjectBug": "Bug",
  "contact.subjectFeedback": "User feedback",
  "contact.subjectCollaboration": "Collaboration",
  "contact.subjectFeatureIdea": "Feature idea",
  "contact.subjectOther": "Other",

  // ----- Use Case Section -----
  "usecase.title": "Use Cases",
  "usecase.intro":
    "Check out these use case examples below to get a concrete idea of how Flots can be used in your daily life.",
  "usecase.question": "You are?",
  "usecase.independent": "Freelancer",
  "usecase.smallBusiness": "Small Business",
  "usecase.indepTitle": "Case of Sylvie, Independent Graphic Designer",
  "usecase.indepIntro":
    "Sylvie specializes in graphic design. She creates logos, brand guidelines, and sometimes website designs. She mainly works with small restaurants, which she loves for their proximity and authenticity.",
  "usecase.indepPara1":
    "At the start of each project, she visits the location for an initial client meeting, notebook in hand, ready to note every detail: the colors of the place, the restaurateur's values, the desired atmosphere. But quickly, pages pile up, projects overlap, and ideas get lost in the mass.",
  "usecase.indepPara2":
    "Each mission involves its own deadlines, inspirations, files to deliver, exchanges with printers or developers. Sylvie often finds herself searching where she noted certain information, or when she needs to deliver which visual. Her notebook is no longer enough.",
  "usecase.indepPara3": "That's when a friend tells her about Flots",
  "usecase.indepPara3Suffix":
    ". He also works as a freelancer, and he explains how the app helps him stay in control of his projects without drowning in tools. Intrigued, Sylvie decides to try it.",
  "usecase.indepPara4":
    "With Flots, Sylvie centralizes everything: her projects, notes, appointments, deliverables. Each order becomes a clear, living space where she finds her tasks, ideas, and deadlines. The app allows her to have both a global view of her workload and a local view focused on each client.",
  "usecase.indepPara5":
    "When a new project starts, she creates it in the app. She adds key dates, scouting notes, mockups to validate, and even automatic reminders for client follow-ups. No more juggling between multiple tools:",
  "usecase.indepPara5Bold": "Flots adapts to her way of working",
  "usecase.pmeTitle": "Small Business Case",
  "usecase.pmeIntro":
    "A small team of about ten people brings together technical and commercial profiles. Their daily routine is punctuated by client meetings, internal reviews, and tracking multiple projects in parallel.",
  "usecase.pmePara1":
    "Everyone takes notes their own way: some on their phone, others on their computer, still others in a notebook.",
  "usecase.pmePara2":
    "Gradually, information disperses and reminders pile up. Exchanges happen through messages, often unread, and urgent tasks sometimes go unnoticed.",
  "usecase.pmePara3":
    "They tried using Notion to centralize their work, but the tool proved too complex for their needs. Creating and maintaining pages took more time than they gained.",
  "usecase.pmePara4":
    "The team went back to simpler tools, but without real coordination: no overview, no link between notes, tasks, and calendars.",
  "usecase.pmePara5":
    "The need then became clearer: to have a shared space, clear and quick to use, capable of linking their exchanges, actions, and deadlines.",
  "usecase.pmePara6":
    "With Flots, they find a balance between structure and simplicity. After a meeting, a team member enters their notes directly into the app.",
  "usecase.pmePara7":
    "Actions to take are automatically detected and transformed into tasks. These appear in the team's calendar, connected to Google Calendar, and can be assigned or reorganized according to priorities.",
  "usecase.pmePara8":
    "The timeline or Gantt view gives an immediate vision of progress, without requiring complex setup.",
  "usecase.pmePara9":
    "The team no longer spends time synchronizing tools or copying information. Everyone sees what they need to do, when, and with whom. Discussions take their place in work rather than in reminders.",
  "usecase.pmePara10":
    "Information flows better, follow-ups become more reliable, and collective mental load decreases",

  // ----- Team page (a story in four chapters; lorem ipsum until the copy is written) -----
  "team.hero.title": "Lorem ipsum dolor sit amet consectetur",
  "team.hero.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.hero.cta": "Read our story",
  "team.chapter.of": "Chapter {n} of {total}: ",
  "team.chapter.who.label": "Who we are",
  "team.chapter.who.title": "Lorem ipsum dolor sit amet",
  "team.chapter.who.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.why.label": "Why us",
  "team.chapter.why.title": "Lorem ipsum dolor sit amet",
  "team.chapter.why.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.origin.label": "Where we started",
  "team.chapter.origin.title": "Lorem ipsum dolor sit amet",
  "team.chapter.origin.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.next.label": "Where we're going",
  "team.chapter.next.title": "Lorem ipsum dolor sit amet",
  "team.chapter.next.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.founder.photoAlt": "Portrait of {name}",
  "team.founder.killian.role": "Lorem ipsum dolor",
  "team.founder.killian.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.killian.tag1": "Lorem ipsum",
  "team.founder.killian.tag2": "Dolor sit",
  "team.founder.killian.tag3": "Amet",
  "team.founder.sylvain.role": "Lorem ipsum dolor",
  "team.founder.sylvain.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.sylvain.tag1": "Lorem ipsum",
  "team.founder.sylvain.tag2": "Dolor sit",
  "team.founder.sylvain.tag3": "Amet",
  "team.founder.erwan.role": "Lorem ipsum dolor",
  "team.founder.erwan.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.erwan.tag1": "Lorem ipsum",
  "team.founder.erwan.tag2": "Dolor sit",
  "team.founder.erwan.tag3": "Amet",
  "team.stat.s1": "Lorem ipsum dolor sit amet",
  "team.stat.s2": "Lorem ipsum dolor sit amet",
  "team.stat.s3": "Lorem ipsum dolor sit amet",
  "team.stat.s4": "Lorem ipsum dolor sit amet",
  "team.reason.r1.title": "Lorem ipsum dolor",
  "team.reason.r1.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.reason.r2.title": "Lorem ipsum dolor",
  "team.reason.r2.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.reason.r3.title": "Lorem ipsum dolor",
  "team.reason.r3.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m1.date": "October 2024",
  "team.milestone.m1.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m1.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m2.date": "Winter 2024",
  "team.milestone.m2.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m2.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m3.date": "February 2025",
  "team.milestone.m3.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m3.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m4.date": "April 2025",
  "team.milestone.m4.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m4.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m5.date": "2026",
  "team.milestone.m5.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m5.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m1.alt": "Erwan and Sylvain in Paris, holding the prototype",
  "team.milestone.m2.alt": "The first Flots prototype",
  "team.milestone.m5.alt": "The team's workstation at InnovLab",
  "team.milestone.now": "Today",
  "team.next.manifesto": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.horizon.h1.when": "Lorem ipsum",
  "team.horizon.h1.title": "Lorem ipsum dolor sit",
  "team.horizon.h1.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.horizon.h2.when": "Lorem ipsum",
  "team.horizon.h2.title": "Lorem ipsum dolor sit",
  "team.horizon.h2.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.horizon.h3.when": "Lorem ipsum",
  "team.horizon.h3.title": "Lorem ipsum dolor sit",
  "team.horizon.h3.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.outro.title": "Lorem ipsum dolor sit amet",
  "team.outro.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.outro.try": "Try Flots",
  "team.outro.contact": "Write to us",

  // ----- Fund Section -----
  "fund.title": "Support Us!",
  "fund.students": "we are all 4 students",
  "fund.description1": "As you must have understood,",
  "fund.description1End":
    "and as you probably know, this is not the socio-professional category with the most abundant and stable income.",
  "fund.description2":
    "If you feel like it, you can help us financially to support development and deployment costs. For the coming months, we're keeping the app free to access so we won't have any direct revenue.",
  "fund.goal":
    "We want to wait until we reach satisfactory quality before monetizing the application",
  "fund.closing":
    "There you go, you have the donation link right below that we will fully reinvest in the project :) (don't break your piggy banks though)",
  "fund.thanks": "Thank you so much!!",
  "fund.cta": "Support Us",

  // ----- Footer -----
  "theme.label": "Theme",
  "theme.system": "Automatic (device)",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "footer.copyright": "© 2026, Sinyx Studio · Flots, All rights reserved",
  "footer.presentation": "Presentation",
  "footer.application": "The Application",
  "footer.features": "Our Features",
  "footer.pricing": "Our Pricing",
  "footer.team": "Our Team",
  "footer.privacy": "Privacy Policy",
  "footer.refund": "Refund Policy",
  "footer.terms": "Terms of Use",
  "footer.privacyFr": "Privacy Policy (FR)",
  "footer.privacyEn": "Privacy Policy (EN)",
  "footer.contactUs": "Contact Us",

  // ----- 404 Page -----
  "notFound.error": "ERROR",
  "notFound.message":
    "The page was not found. Please check the URL or return to the home page.",
  "notFound.home": "Home",

  // ----- Language Switcher -----
  "language.switch": "FR",

  // ----- Accessibility -----
  "a11y.brandHome": "Flots, home",
  "a11y.menuOpen": "Open menu",
  "a11y.promoClose": "Close the promotional banner",
  "a11y.menuClose": "Close menu",
  "a11y.navigationMenu": "Navigation menu",
  "a11y.ressourcesCategories": "Show resource categories",
  "a11y.languageSwitch": "FR, switch to French",
  "a11y.downloadGooglePlay": "Download Flots on Google Play",
  "a11y.downloadAppStore": "Download Flots on the App Store",
  "a11y.openWebApp": "Open the Flots Web App",
  "a11y.cap": "Cap, the Flots assistant",
  "a11y.carousel.previous": "Previous",
  "a11y.carousel.next": "Next",
  "a11y.carousel.slide": "Slide {number}",
  "a11y.video.resume": "Resume playback",
  "a11y.video.pause": "Pause playback",
  "a11y.video.enterFullscreen": "Enter fullscreen",
  "a11y.video.exitFullscreen": "Exit fullscreen",
  "a11y.video.volume": "Volume",
  "a11y.video.unmute": "Unmute",
  "a11y.video.mute": "Mute",
  "a11y.close": "Close",
  "a11y.features.titleImage": "Illustration of Flots features",
  "a11y.features.centralizationImage": "Illustration of centralized management",
  "a11y.features.suggestionsImage": "Illustration of automatic suggestions",
  "a11y.features.notificationsImage": "Illustration of smart notifications",
  "a11y.application.organizationImage": "Illustration of an organization using Flots",
  "a11y.application.managementImage": "Illustration of centralized management with Flots",
  "a11y.profile.organizationImage": "Illustration of team management with Flots",
  "a11y.profile.collaborationImage": "Illustration of team collaboration in Flots",
  "a11y.profile.delegationImage": "Illustration of task delegation and tracking in Flots",
  "a11y.profile.interfaceImage": "Illustration of the intuitive Flots interface",
  "a11y.profile.productivityImage": "Illustration of a productive team member using Flots",
  "a11y.profile.onboardingImage": "Illustration of getting started with Flots in 5 minutes",
  "a11y.profile.longTermImage": "Illustration of effective long-term organization",
  "a11y.profile.featureIcon": "Flots icon for {feature}",
  // ----- Additional Component Keys -----
  "pricing.teamArrival": "Coming mid-February",
  "pricing.teamInterested": "interested?",
  "pricing.teamContact": "Contact Us",

  "contact.formDescription":
    "Use this form to contact us. We'll get back to you as soon as possible. Feel free to provide as much detail as possible to get a relevant response faster.",
  "contact.namePlaceholder": "Name",
  "contact.emailPlaceholder": "Email",
  "contact.subjectLabel": "SUBJECT",
  "contact.subjectSelect": "Select a subject",
  "contact.contentLabel": "CONTENT",
  "contact.contentPlaceholder": "Describe your request",
  "contact.send": "SEND",

  "usecase.subtitle":
    "Check out these use case examples below to get a concrete idea of how Flots can fit into your daily routine.",
  "usecase.buttonIndep": "Freelancer",
  "usecase.buttonPME": "Small Business",
  "usecase.indepParagraph1":
    "At the start of each project, she visits the site for an initial client meeting, notebook in hand, ready to note every detail: the colors of the place, the restaurateur's values, the desired atmosphere. But quickly, the pages pile up, projects overlap, and ideas get lost in the mass.",
  "usecase.indepParagraph2":
    "Each assignment comes with its own deadlines, inspirations, files to deliver, exchanges with printers or developers. Sylvie often finds herself searching for where she noted that info, or when she needs to deliver that visual. Her notebook is no longer enough.",
  "usecase.indepParagraph3":
    "<b>That's when a friend tells her about Flots</b>. He also works freelance, and he explains how the app helps him stay in control of his projects without drowning in tools. Intrigued, Sylvie decides to try it.",
  "usecase.indepParagraph4":
    "When a new project starts, she creates it in the app. She adds key dates, scouting notes, mockups to validate, and even automatic reminders for client follow-ups. No more juggling between multiple tools: <b>Flots adapts to her way of working.</b>",
  "usecase.indepParagraph5":
    "With Flots, Sylvie centralizes everything: her projects, notes, appointments, deliverables. Each order becomes a clear, living space where she finds her tasks, ideas, and deadlines. The app allows her to have both a global view of her workload and a local view focused on each client.",
  "usecase.pmeParagraph1a":
    "Everyone takes notes their own way: some on their phone, others on their computer, others still in a notebook.",
  "usecase.pmeParagraph1b":
    "Gradually, information gets scattered and reminders pile up. Exchanges happen through messages, often unread, and urgent tasks sometimes go unnoticed.",
  "usecase.pmeParagraph2a":
    "They tried using Notion to centralize their work, but the tool turned out to be too complex for their needs. Creating and maintaining pages took more time than they saved.",
  "usecase.pmeParagraph2b":
    "The team went back to simpler tools, but without real coordination: no overview, no link between notes, tasks, and calendars.",
  "usecase.pmeParagraph3a":
    "The need then became clear: having a shared space, clear and quick to use, able to connect their exchanges, actions, and deadlines.",
  "usecase.pmeParagraph3b":
    "With Flots, they find a balance between structure and simplicity. After a meeting, a team member enters their notes directly into the app.",
  "usecase.pmeParagraph4a":
    "Actions to be taken are automatically detected and converted into tasks. These appear in the team calendar, connected to Google Calendar, and can be assigned or reorganized according to priorities.",
  "usecase.pmeParagraph4b":
    "The timeline or Gantt view gives an immediate vision of progress, without requiring complex setup.",
  "usecase.pmeParagraph5a":
    "The team no longer spends time synchronizing tools or copying information. Everyone sees what they need to do, when, and with whom. Discussions return to their place in work rather than in reminders.",
  "usecase.pmeParagraph5b":
    "Information flows better, follow-ups become more reliable, and collective mental load decreases",

  // ----- Use Case Section - Individual content -----
  "usecase.indiv.banner.label": "Flots for individuals",
  "usecase.indiv.banner.title": "What we offer you.",
  "usecase.indiv.s1.title": "A system that adapts.",
  "usecase.indiv.s1.c1.title": "Based on your challenges.",
  "usecase.indiv.s1.c1.desc":
    "Keep it simple, the app keeps it simple. If you want detail, the app allows it too.",
  "usecase.indiv.s1.tag1": "Procrastination",
  "usecase.indiv.s1.tag2": "Hard to focus",
  "usecase.indiv.s1.tag3": "Multitasking",
  "usecase.indiv.s1.tag4": "Overwhelmed",
  "usecase.indiv.s1.c2.title": "Plan your workloads",
  "usecase.indiv.s1.c2.desc":
    "Schedule your days in a few clicks based on your schedule.",
  "usecase.indiv.s1.c3.title": "Your Cap",
  "usecase.indiv.s1.c3.desc":
    "Friendly, pragmatic... choose the qualities of an assistant that matches your needs.",
  "usecase.indiv.s2.title": "Simple tools to get started.",
  "usecase.indiv.s2.c1.title": "5 minutes, that's all!",
  "usecase.indiv.s2.c1.desc":
    "That's how long it takes to get up to speed with Flots and understand its strengths.",
  "usecase.indiv.s2.c2.title": "A clear and accessible interface",
  "usecase.indiv.s2.c2.desc":
    "We provide ergonomics that let you see what truly matters.",
  "usecase.indiv.s2.tools.label": "Features you already know how to use.",
  "usecase.indiv.s2.tool1.title": "Task management",
  "usecase.indiv.s2.tool1.desc": "List what needs to be done, then do it",
  "usecase.indiv.s2.tool2.title": "Built-in agenda",
  "usecase.indiv.s2.tool2.desc": "Your schedule at a glance",
  "usecase.indiv.s2.tool3.title": "Write notes",
  "usecase.indiv.s2.tool3.desc": "Capture your ideas on the fly",
  "usecase.indiv.s2.tool4.title": "Manage your projects",
  "usecase.indiv.s2.tool4.desc": "Drive and track your progress",
  "usecase.indiv.s3.title": "Organization built for the long run.",
  "usecase.indiv.s3.c1.title": "Track where you stand on your projects",
  "usecase.indiv.s3.c1.desc":
    "See at a glance what's progressed, what's next, what's blocking...",
  "usecase.indiv.s3.c2.title": "Categorize cleanly",
  "usecase.indiv.s3.c2.desc":
    "Segment your daily topics however you need.",
  "usecase.indiv.s3.c3.title": "Built to last",
  "usecase.indiv.s3.c3.desc":
    "Build a lasting organization that evolves with you.",
  "usecase.indiv.s3.tag1": "Personal",
  "usecase.indiv.s3.tag2": "Work",
  "usecase.indiv.s3.tag3": "Health",
  "usecase.indiv.s3.tag4": "Hobbies",

  // ----- Use Case Section - Organisation content -----
  "usecase.org.banner.label": "Flots for organisations",
  "usecase.org.banner.title": "What we offer you.",
  "usecase.org.s1.title": "Multi-person organisation, simplified.",
  "usecase.org.s1.c1.title": "Manage your projects together.",
  "usecase.org.s1.c1.desc":
    "Work in shared spaces designed for fast management. Get the information you need while intelligently adding new information.",
  "usecase.org.s1.c2.title": "Your information centralised.",
  "usecase.org.s1.c2.desc":
    "No more time wasted tracking down crucial information. Have everything your team needs to move forward in one place.",
  "usecase.org.s1.c3.title": "Delegate, Supervise, in 2 clicks",
  "usecase.org.s1.c3.desc": "Assign without friction.",
  "usecase.org.s2.title": "Every collaborator valued.",
  "usecase.org.s2.c1.title": "Intuitive onboarding.",
  "usecase.org.s2.c1.desc":
    "With its ergonomic interface, it has never been faster to set up a solid organisation.",
  "usecase.org.s2.c2.title": "Individual consideration",
  "usecase.org.s2.c2.desc":
    "We give individuals the tools to serve the collective. We address your team's challenges at the root.",
  "usecase.org.cta": "Learn more",
  "usecase.indiv.cta": "Discover for organisations",

  "nav.features.indiv.label": "Individuals",
  "nav.features.org.label": "Organisations",
  "nav.features.indiv.s1.desc": "Based on your challenges",
  "nav.features.indiv.s2.desc": "Tasks, agenda, notes and projects",
  "nav.features.indiv.s3.desc": "Track your long-term progress",
  "nav.features.org.s1.desc": "Manage projects together",
  "nav.features.org.s2.desc": "Individual consideration for each",


  "fund.support": "Support Us",

  "footer.privacyFR": "Privacy Policy (FR)",
  "footer.privacyEN": "Privacy Policy (EN)",
  "footer.contact": "Contact Us",
  "footer.nav.title": "Navigation",
  "footer.legal.title": "Legal",
  "footer.features.title": "Features",
  "footer.legalNotice": "Legal Notice",
  "footer.cgv": "Terms of Sale",
  "footer.manageCookies": "Manage cookies",

  // ----- Cookie banner -----
  "cookieBanner.text":
    "We use browsing data for internal statistical purposes. You can accept or decline.",
  "cookieBanner.accept": "Accept",
  "cookieBanner.reject": "Decline",
  "cookieBanner.learnMore": "Learn more",

  // ----- Feature Discovery Modal -----
  "fd.next": "Next",
  "fd.done": "Done",

  "fd.tasks.simple.title": "A task, simply",
  "fd.tasks.simple.p1": "A task is fundamentally simple: a title is enough. You can create one in 2 clicks.",
  "fd.tasks.simple.p2": "Note what you have to do, then get back to work quickly.",

  "fd.tasks.details.title": "The option to add detail",
  "fd.tasks.details.p1": "If you want to add categories, sub-tasks, a description, or a recurrence every Tuesday or Thursday, that's also possible.",
  "fd.tasks.details.p2": "We aim for the essentials, but you have the freedom to go as far as your needs require.",

  "fd.tasks.notifications.title": "Notifications at the right time",
  "fd.tasks.notifications.p1": "Enable notifications and be alerted at the right moment.",
  "fd.tasks.notifications.p2": "We are working on systems to surface information exactly when you are available to receive it.",

  "fd.calendar.classic.title": "A classic calendar",
  "fd.calendar.classic.p1": "Flots works just like the calendars you already know.",
  "fd.calendar.classic.p2": "Create your work blocks and appointments in one click, then connect it to Google Calendar easily.",

  "fd.calendar.workingHours.title": "Set your working hours",
  "fd.calendar.workingHours.p1": "Indicate your working periods so the app can adapt to your schedule.",

  "fd.calendar.planDay.title": "Plan your day in 5 minutes",
  "fd.calendar.planDay.p1": "Simply sort your tasks and place them in your calendar for a well-planned day.",

  "fd.notes.capture.title": "Note everything, in 2 clicks",
  "fd.notes.capture.p1": "Your notes stay well organised. Write, categorise, format with the toolbar or directly in Markdown.",
  "fd.notes.capture.p2": "Capture information quickly, then get back to work without friction.",

  "fd.notes.suggestions.title": "From notes to tasks: automatic suggestion",
  "fd.notes.suggestions.p1": "Automatically extract your tasks from meeting notes, summaries, emails or drafts.",
  "fd.notes.suggestions.p2": "They are then directly referenced in Flots so nothing falls through the cracks.",

  "fd.projects.focus.title": "Focus on one subject",
  "fd.projects.focus.p1": "Have isolated spaces that list your entire organisation for a specific topic.",
  "fd.projects.focus.p2": "Projects let you properly file your tasks and notes, track milestones, or share with collaborators.",

  "fd.projects.pins.title": "Pinned items",
  "fd.projects.pins.p1": "Pin the core elements of your projects to the front page: the things you always come back to when working on a topic.",

  "fd.projects.milestones.title": "Milestones",
  "fd.projects.milestones.p1": "Track where you are.",
  "fd.projects.milestones.p2": "See the key steps and the critical path to where you need to go.",

  "fd.projects.collaboration.title": "Collaborate!",
  "fd.projects.collaboration.p1": "Share your project organisation, assign tasks, and share notes.",
  "fd.projects.collaboration.p2": "Move forward together clearly, all connected to your personal organisation.",

  // ----- Exit intent popup -----
  "exit.title": "Leaving already?",
  "exit.description":
    "Before you close the tab, give it 5 minutes, that's all it takes to set up your organisation in Flots.",
  "exit.perk1": "2 months free, no credit card",
  "exit.perk2": "Tasks, calendar, notes and projects in one place",
  "exit.perk3": "5 minutes are enough to get the hang of the app",
  "exit.cta": "Try Flots for free",
  "exit.stay": "Keep browsing",

  // ----- Ressources -----
  "nav.ressources": "Resources",
  "footer.ressources": "Resources",
  "ressources.landing.title": "Resources",
  "ressources.landing.description": "Practical guides, productivity methods and app news.",
  "ressources.recent.title": "Latest resources",
  "ressources.readingTime": "{minutes} min read",
  "ressources.cta.default": "Try in Flots",
  "ressources.rappel.label": "Reminder",
  "ressources.publishedOn": "Published on {date}",
  "ressources.backToCategory": "Back",
  "ressources.backToList": "All resources",
  "ressources.related.title": "Related articles",
  "ressources.faq.title": "Frequently asked questions",
  "ressources.tags.all": "All topics",
  "ressources.empty.title": "No articles in this category",
  "ressources.category.guides.label": "Guides",
  "ressources.category.guides.desc": "Flots onboarding, step-by-step tutorials and demo videos.",
  "ressources.category.productivite.label": "Productivity",
  "ressources.category.productivite.desc": "Organisation methods and best practices for solo or team work.",
  "ressources.category.actualites.label": "News",
  "ressources.category.actualites.desc": "App updates, announcements and team news.",
  "ressources.category.temoignages.label": "Testimonials",
  "ressources.category.temoignages.desc": "Experience reports from teams and freelancers using Flots.",
  "ressources.new.label": "New",
  "ressources.filter.allFormats": "All",
  "ressources.filter.noResults": "No articles match these filters.",
  "ressources.format.tutoriel": "Tutorial",
  "ressources.format.decouverte": "Discovery",
  "ressources.format.bonnesPratiques": "Best practices",
  "ressources.format.actualite": "News",
  "ressources.format.casPratique": "Case study",

  // ----- Resources: intro (/resources) -----
  "resources.hero.title": "Resources",
  "resources.hero.lead":
    "Guides to get started with Flots, methods to get organised, and what's new in the app.",
  "resources.hero.guide.title": "Getting started with Flots",
  "resources.hero.guide.desc": "The step-by-step guide, from your first task to your team.",
  "resources.hero.browse": "Browse by category",
  "resources.hero.replay": "Replay the categories animation",
  "resources.hero.count": "{count, plural, =0 {Coming soon} one {# article} other {# articles}}",
  "resources.hero.animation":
    "The four resource categories: guides, productivity, news and testimonials",

  // ----- Getting-started guide (/guide) -----
  "guide.title": "Getting started with Flots",
  "guide.lead":
    "Seven steps to set up your organisation, from your first task to your team. For each one: what to do, and a short demo.",
  "guide.cta.signup": "Create my account",
  "guide.toc.label": "Guide contents",
  "guide.toc.title": "First steps",
  "guide.toc.features": "Every feature",
  "guide.toc.resources": "All resources",
  "guide.howto": "How to",
  "guide.readMore": "Go further",
  "guide.tip": "Tip",
  "guide.step.of": "Step {n} of {total}",

  "guide.step.premiere-tache.title": "Create your account and your first task",
  "guide.step.premiere-tache.lead":
    "Flots works on the web, on iPhone and on Android. A task starts with just a title: write it down, then get back to work.",
  "guide.step.premiere-tache.how.1":
    "Open Flots at <b>dashboard.flots.app</b> or install the mobile app, then create your account.",
  "guide.step.premiere-tache.how.2": "Add a task: a title is enough, two clicks and it's saved.",
  "guide.step.premiere-tache.how.3":
    "Open it only when you need to, to give it a category, sub-tasks or a description.",
  "guide.step.premiere-tache.how.4": "Tick it once it's done.",
  "guide.step.premiere-tache.tip":
    "A task that comes back every week? Give it a recurrence: it comes back on its own at the right time.",

  "guide.step.agenda.title": "Connect your calendar",
  "guide.step.agenda.lead":
    "Your existing meetings show up in Flots, next to your tasks. Nothing to copy over, one calendar to keep.",
  "guide.step.agenda.how.1": "Open <b>Settings</b>, then the <b>Calendar</b> section and the <b>Connections</b> tab.",
  "guide.step.agenda.how.2": "Connect your Google Calendar account, then pick the calendars to sync.",
  "guide.step.agenda.how.3":
    "A timetable published as .ics? Paste its address in the <b>ICS calendar link</b> block.",
  "guide.step.agenda.how.4":
    "Give each calendar a colour: you see at a glance what comes from outside.",

  "guide.step.journee.title": "Plan your day",
  "guide.step.journee.lead":
    "Your tasks and your calendar on one screen: in a few minutes you know where to start and what the day can hold.",
  "guide.step.journee.how.1": "Set your working hours, once and for all.",
  "guide.step.journee.how.2":
    "Open the <b>Planning</b> view: today's tasks sit in their time slots, undated ones wait on the side.",
  "guide.step.journee.how.3": "Drag a task onto a free slot.",
  "guide.step.journee.how.4": "Switch to the week view to spread the load from one day to the next.",
  "guide.step.journee.tip":
    "Cap, the Flots assistant, helps you sort what needs doing and place your tasks in your time slots.",

  "guide.step.notes.title": "Turn your notes into tasks",
  "guide.step.notes.lead":
    "Take notes the way you always do. Flots spots the actions they contain and brings them to the top of the note, ready to organise.",
  "guide.step.notes.how.1": "Create a note in two clicks and write, during the meeting or right after.",
  "guide.step.notes.how.2": "Format it with the toolbar, or straight in Markdown.",
  "guide.step.notes.how.3": "Find the tasks Flots spotted at the top of the note.",
  "guide.step.notes.how.4": "File the note in a category or a project so you never have to search for it.",
  "guide.step.notes.tip":
    "Hands full? On mobile, record a voice note from Docs: it's filed just like a note.",

  "guide.step.projet.title": "Gather a topic in a project",
  "guide.step.projet.lead":
    "A client, a case, a long-running job: a project brings its tasks, notes, documents and milestones together in one place.",
  "guide.step.projet.how.1": "Create a project for the topic that keeps you busiest right now.",
  "guide.step.projet.how.2": "Add your tasks and notes to it, and upload the documents that go with them.",
  "guide.step.projet.how.3": "Set the project's milestones: you see what's done and what comes next.",
  "guide.step.projet.how.4":
    "Pin the brief or the reference note: they're waiting for you every time you open the project.",

  "guide.step.equipe.title": "Invite your team",
  "guide.step.equipe.lead":
    "A project is shared with the people who work on it. Everyone sees what's theirs, without a follow-up meeting.",
  "guide.step.equipe.how.1": "Open the project you want to share, then its list of members.",
  "guide.step.equipe.how.2": "Add each person with the email of their Flots account.",
  "guide.step.equipe.how.3":
    "Pick their role: <b>Editor</b> to read and write, <b>Reader</b> to view only.",
  "guide.step.equipe.how.4":
    "Assign them a task: it shows up in their list, and progress updates as soon as they tick it.",
  "guide.step.equipe.tip":
    "Notes in a shared project are written together, live: a banner shows who is on the note.",

  "guide.step.import.title": "Bring your Notion or Todoist data",
  "guide.step.import.lead":
    "No need to start from scratch: Flots connects to your account and brings over your projects, tasks and notes, with no file to export.",
  "guide.step.import.how.1": "In the Flots settings, choose to import from Notion or Todoist.",
  "guide.step.import.how.2": "Allow access to your account, just like linking a Google account to another tool.",
  "guide.step.import.how.3": "Flots rebuilds your projects, tasks and notes. Nothing to sort out afterwards.",
  "guide.step.import.tip":
    "A Notion database with a status column becomes a project and its tasks; a Todoist project becomes a Flots project.",
  "guide.step.import.cta": "Start the import",

  "guide.features.title": "Every feature",
  "guide.features.lead": "Each tool has its own detailed guide in the resources.",
  "guide.features.group.organize": "Get organised",
  "guide.features.group.write": "Write and file",
  "guide.features.group.team": "Work together",
  "guide.features.group.connect": "Connect your tools",
  "guide.feature.tasks.title": "Tasks",
  "guide.feature.tasks.desc": "A title is enough. Categories, sub-tasks, recurrence and reminders when you need them.",
  "guide.feature.agenda.title": "Calendar and Planning view",
  "guide.feature.agenda.desc": "Your meetings and your tasks on one screen, by day or by week.",
  "guide.feature.cap.title": "Cap, the assistant",
  "guide.feature.cap.desc": "It helps you plan your days and keeps what matters in sight.",
  "guide.feature.notes.title": "Notes",
  "guide.feature.notes.desc": "Markdown, categories, an automatic outline and tasks spotted in the text.",
  "guide.feature.documents.title": "Documents",
  "guide.feature.documents.desc": "PDFs and images filed in folders, linked to your notes and projects.",
  "guide.feature.whiteboards.title": "Whiteboards",
  "guide.feature.whiteboards.desc": "Shapes, arrows and text to sketch a diagram, attached to a project.",
  "guide.feature.projects.title": "Projects",
  "guide.feature.projects.desc": "One space per topic, with its milestones, pinned items and members.",
  "guide.feature.live.title": "Live editing",
  "guide.feature.live.desc": "Notes and whiteboards in a shared project are written by several people at once.",
  "guide.feature.workload.title": "Team workload",
  "guide.feature.workload.desc": "The Planning week view shows who is busy and who has room.",
  "guide.feature.calendars.title": "Google Calendar and .ics",
  "guide.feature.calendars.desc": "Your existing calendars in Flots, each in its own colour.",
  "guide.feature.import.title": "Notion and Todoist import",
  "guide.feature.import.desc": "Projects, tasks and notes brought over from your account, with no file to export.",
  "guide.feature.mcp.title": "AI assistants (MCP)",
  "guide.feature.mcp.desc": "Connect Claude or another compatible assistant to Flots, with the permissions you choose.",

  "guide.help.title": "A question?",
  "guide.help.desc": "A European team replies within 24 hours.",
  "guide.help.contact": "Write to us",

  // ----- Business card (/card) -----
  "footer.card": "Business card",
  "card.tagline": "Your organisation, simplified",

  "card.point1.title": "Everything in one place",
  "card.point2.title": "A secretary in your pocket",
  "card.point3.title": "Made and hosted in Europe",

  "card.qr.title": "Scan to install Flots",

  "card.platform.web.label": "Web",
  "card.platform.web.store": "dashboard.flots.app",
  "card.platform.web.devices": "Browser, tablet and iPad",
  "card.platform.android.label": "Android",
  "card.platform.android.store": "Google Play",
  "card.platform.android.devices": "Android phones and tablets",
  "card.platform.ios.label": "iOS",
  "card.platform.ios.store": "App Store",
  "card.platform.ios.devices": "iPhone and iPad",

  "card.catchphrase": "Stop juggling ten different apps.",
  "card.catchphraseSub":
    "Focus on your actual work, not on staying organised.",

  "a11y.card.previous": "Previous platform",
  "a11y.card.next": "Next platform",
  "a11y.card.qr": "QR code to install Flots for {platform}",

  // ----- Accessibility pass (skip link, landmarks, forms, filters) -----
  "a11y.skipToContent": "Skip to main content",
  "a11y.mainNav": "Main navigation",
  "a11y.video.pauseLoop": "Pause the animation",
  "a11y.video.playLoop": "Play the animation",
  "contact.label.subject": "Subject",
  "contact.label.message": "Message",
  "contact.allRequired": "All fields are required.",
  "contact.error.name": "Please enter your name.",
  "contact.error.email": "Please enter a valid email address, for example name@example.com.",
  "contact.error.subject": "Please choose a subject.",
  "contact.error.content": "Please write your message.",
  "contact.error.send": "Your message couldn't be sent. Please try again in a moment.",
  "ressources.tags.label": "Filter by topic",
  "ressources.results": "{count, plural, one {# article} other {# articles}}",
  "ressources.showMore": "Show more articles ({count} left)",

  // ----- Home v4: promise, problem, product tour -----
  "hero.promise": "Your organization runs without you <em>thinking about it</em>.",
  "hero.video.play": "See Flots in action",
  "a11y.video.progress": "Video progress",

  "trust.europe": "Hosted in Europe",
  "trust.devices": "Web, iOS and Android",
  "trust.import": "Import from Notion and Todoist",
  "trust.support": "A European team that answers within 24 h",

  "problem.eyebrow": "The problem",
  "problem.title": "Today, getting organized is a second job",
  "problem.heavy.title": "Either a tool you have to build",
  "problem.heavy.desc": "Big platforms need someone to set up the views and keep them running, and you don't have that person.",
  "problem.scattered.title": "Or five tools you connect in your head",
  "problem.scattered.desc": "Tasks, notes, calendar, files: each in its own corner, and you're the one linking them, every day.",
  "problem.flots.title": "Flots: neither",
  "problem.flots.desc": "Everything is in one place, already organized: open it and get to work.",

  "story.eyebrow": "How it works",
  "story.title": "Everything in one place, ready to use.",
  "story.nav": "Tour steps",
  "story.scrollHint": "Keep scrolling",
  "story.part.problem": "The problem",
  "story.part.build": "Nothing to build",
  "story.part.action": "From meeting to action",
  "story.part.team": "The team",
  "story.part.trust": "Your data",
  "story.group.build": "Nothing to build, nothing to learn",
  "story.group.action": "From meeting to action",
  "story.group.team": "Built for each person, so the team moves",
  "story.group.trust": "Your data stays yours",
  "story.tasks.title": "Write down what needs doing. That's it.",
  "story.tasks.desc":
    "No template to pick, no view to set up: tasks, a calendar, notes, and you're working in five minutes.",
  "story.agenda.title": "Every task gets its slot.",
  "story.agenda.desc":
    "Drag it onto a free hour in your calendar: the time to do it is booked, right next to your meetings.",
  "story.devices.title": "Jotted on your phone, ready on your computer.",
  "story.devices.desc":
    "An idea between two meetings takes two seconds to note, and back at your desk it's already on your list.",
  "story.notes.title": "Your meeting notes become tasks.",
  "story.notes.desc":
    "One button after the meeting: Cap, your assistant, picks out who does what and by when, and you confirm.",
  "story.planday.title": "Your day, ready every morning.",
  "story.planday.desc":
    "At the time you choose, Cap gathers what's planned, what's left from yesterday and what has no date: all you do is rank them.",
  "story.project.title": "Track your projects, nothing to set up.",
  "story.project.desc":
    "Milestones, tasks and documents in one place. Progress updates itself.",
  "story.delegate.title": "Who does what, without a status meeting.",
  "story.delegate.desc":
    "Drag a task to a teammate: they're notified, and everyone sees what's theirs.",
  "story.live.title": "One brief, written together.",
  "story.live.desc":
    "Shared notes and whiteboards, live: everyone writes at the same time, no more “final_v3” sent by email.",
  "story.privacy.title": "Everyone chooses what they share.",
  "story.privacy.desc":
    "A personal appointment stays private, an idea for the client goes to the team in one move: nobody feels watched.",
  "story.europe.title": "Hosted in Europe. Never sold.",
  "story.europe.desc":
    "Your data stays with European hosts and trains no global model. A question? A team answers within 24 hours.",

  "nav.story.tasks.title": "Tasks and calendar",
  "nav.story.tasks.desc": "Nothing to build, nothing to learn",
  "nav.story.notes.title": "Meeting notes",
  "nav.story.notes.desc": "Cap suggests, you confirm",
  "nav.story.planday.title": "The morning ritual",
  "nav.story.planday.desc": "Your day ready at the time you choose",
  "nav.story.project.title": "Projects",
  "nav.story.project.desc": "Tracked with no setup",
  "nav.story.delegate.title": "Delegation",
  "nav.story.delegate.desc": "Who does what, no meeting",
  "nav.story.privacy.title": "Privacy",
  "nav.story.privacy.desc": "Everyone chooses what they share",
  "nav.story.live.title": "Together, live",
  "nav.story.live.desc": "Shared notes and whiteboards",

  "profile.title": "Who are you?",
  "profile.lead": "On your own or as a team, Flots adapts to the way you work.",
  "profile.tablist": "Your profile",
  "profile.replay": "Replay the animation: {title}",
  "profile.individual.tab": "An individual",
  "profile.individual.who": "Freelancer, student, founder",
  "profile.individual.lead": "An organization that follows your day, not the other way round.",
  "profile.individual.cta": "Start for free",
  "profile.organization.tab": "An organization",
  "profile.organization.who": "Team, small business, nonprofit",
  "profile.organization.lead": "Built for each person, so the whole team moves forward.",
  "profile.organization.cta": "Try it with my team",
  "profile.organization.demo": "Book a demo",
  "profile.organization.gains.title": "Your team starts the same day",
  "profile.organization.gains.lead": "No setup project, no training, no retyping.",
  "profile.organization.gains.fiveMinutes.title": "Learnt in five minutes",
  "profile.organization.gains.fiveMinutes.desc":
    "Tasks, a calendar, notes: everyone already knows how to use them.",
  "profile.organization.gains.import.title": "Nothing to retype",
  "profile.organization.gains.import.desc":
    "Your Notion or Todoist tasks come over in one click, filed in their projects.",
  "profile.organization.gains.newcomer.title": "New hire? One email is enough.",
  "profile.organization.gains.newcomer.desc":
    "Add them to the project: its tasks, notes and documents are already waiting.",
  "profile.organization.gains.wanted.title": "A tool people want to open",
  "profile.organization.gains.wanted.desc":
    "Everyone finds their own space and their day ready: people adopt it instead of putting up with it.",

  "trust.lead":
    "Data sovereignty is at the heart of how we build Flots: what you put in it belongs to you.",
  "trust.personal.title": "Your personal space",
  "trust.personal.desc": "Your notes, your tasks, your chats with Cap: private, even from your employer.",
  "trust.company.title": "Your company's space",
  "trust.company.desc": "The quote, the shop photos: filed in its projects, the team finds them. By default, nothing else is visible.",
  "trust.hosted": "Hosted in Europe",
  "trust.neverSold": "Never sold",
  "trust.noTraining": "No global model trained on it",

  "finalCta.morningAlt":
    "Morning in Flots: under “Start with”, the “Send quote v2” card lands on top of your day.",

};

export default en;
